module.exports = __webpack_public_path__ + "static/lessons-sweet-potato-0ee19f7e7106af8b19504b53fc87542d.jpg";